import { toApiStatus, toUiStatus } from './_helpers';

/** API Vendor ↔ UI vendor master fields. */

export function vendorFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    vendorId: row.code ?? '',
    gstNumber: row.gstNumber ?? '',
    tradeAgencyName: row.tradeName ?? '',
    constitution: row.constitution ?? '',
    dateOfIncorporation: row.dateOfIncorporation ?? '',
    ownerName: row.ownerName ?? '',
    fatherHusbandName: row.fatherHusbandName ?? '',
    surname: row.surname ?? '',
    ownerFullName: row.ownerFullName ?? '',
    mobile: row.mobile ?? '',
    email: row.email ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    villageId: row.village?.code ?? row.villageId ?? '',
    villageDbId: row.villageId ?? null,
    pin: row.pin ?? '',
    buId: row.businessUnit?.code ?? row.buId ?? '',
    buDbId: row.buId ?? null,
    siteId: row.site?.code ?? row.siteId ?? '',
    siteDbId: row.siteId ?? null,
    kronosNumber: row.kronosNumber ?? '',
    localProfessional: row.localProfessional ?? '',
    majorCategory: row.majorCategory ?? '',
    photo: null,
    aadhaarNumber: '',
    pan: '',
    verificationStatus: toUiStatus(row.verificationStatus),
    rejectionReason: row.rejectionReason ?? '',
    blockReason: row.blockReason ?? '',
    portalToken: row.portalToken ?? '',
    portalTokenIssuedAt: row.portalTokenIssuedAt ?? null,
    registrationSource: row.registrationSource ?? '',
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function vendorToApi(ui) {
  if (!ui) return null;
  return {
    gstNumber: ui.gstNumber || null,
    tradeName: ui.tradeAgencyName,
    constitution: ui.constitution || null,
    dateOfIncorporation: ui.dateOfIncorporation || null,
    ownerName: ui.ownerName,
    fatherHusbandName: ui.fatherHusbandName || null,
    surname: ui.surname || null,
    ownerFullName: ui.ownerFullName || null,
    mobile: ui.mobile,
    email: ui.email || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    villageId: ui.villageDbId ?? ui.villageId,
    pin: ui.pin || null,
    buId: ui.buDbId ?? ui.buId,
    siteId: ui.siteDbId ?? ui.siteId ?? null,
    kronosNumber: ui.kronosNumber || null,
    localProfessional: ui.localProfessional || null,
    majorCategory: ui.majorCategory || null,
    verificationStatus: ui.verificationStatus
      ? toApiStatus(ui.verificationStatus)
      : undefined,
    rejectionReason: ui.rejectionReason || null,
    blockReason: ui.blockReason || null,
    isActive: ui.active !== false,
  };
}
